import React, { Component, Fragment } from 'react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import Collapse from 'components/fulcrum/collapse/Collapse'
import { IconButton } from 'react-toolbox/lib/button'
import cn from 'classnames'
import MoreInfo from 'components/custom/MoreInfo'
import T from 'i18n-react'
import { compose } from 'recompose'
import { mapProps } from 'recompose'
import { GLOBAL_ROLES, PROJECT_ROLES, PRODUCT_ROLES } from 'containers/Role/constants'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import notifyHoc from 'containers/App/Notification/Notify'
import Input from 'components/fulcrum/input/Input'
import Dialog from 'react-toolbox/lib/dialog'
import { connect } from 'react-redux'
import Divider from 'components/fulcrum/divider/Divider'
import { MODULE_NAME } from './constants'
import injectSagas from 'helpers/injectSagas'
import {
    projectDescriptionCollapseSelector,
    projectDescriptionEditSelector,
    projectDescriptionTextSelector,
    projectDescriptionRiskSelector,
    projectDescriptionSourceSelector
} from './selectors'
import {
    toggleDescriptionCollapse,
    openDescriptionEdit,
    closeDescriptionEdit,
    setDescription,
    toggleRisk,
    saveDescription,
    setDescriptionObj
} from './actions'
import { projectIdSelector, workflowIdSelector } from 'containers/Project/View/selectors'
import FontIcon from 'react-toolbox/lib/font_icon'
import Switch from 'react-toolbox/lib/switch'
import Sagas from './sagas'
import { getMonthDateYearString  } from 'helpers/DateUtil'


const InfoButton = notifyHoc(IconButton)

const mapStateToProps = (state) => {
    return {
        collapse: projectDescriptionCollapseSelector(state),
        edit: projectDescriptionEditSelector(state),
        description: projectDescriptionTextSelector(state),
        descriptionSource: projectDescriptionSourceSelector(state),
        risk: projectDescriptionRiskSelector(state),
        workflowId: workflowIdSelector(state),
        projectId: projectIdSelector(state)
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      toggleCollapse: () => dispatch(toggleDescriptionCollapse()),
      openEdit: () => dispatch(openDescriptionEdit()),
      closeEdit: () => dispatch(closeDescriptionEdit()),
      setDescriptionObj: (obj) => dispatch(setDescriptionObj(obj)),
      setDescription: (value) => dispatch(setDescription(value)),
      toggleRisk: (value) => dispatch(toggleRisk(value)),
      saveDescription: (payload) => dispatch(saveDescription(payload))
    }
  }

const showToTeam = compose(
  mapProps((props) => ({
    ...props,
    roles: [ 
      ...Object.values(PROJECT_ROLES),
      ...Object.values(PRODUCT_ROLES),
      GLOBAL_ROLES.ADMIN_ACCESS
    ]
  })),
  showOnAnyRoles
)

class ProjectDescription extends Component {

    onSave = () => {
      const { saveDescription, description, projectId, risk } = this.props
      saveDescription({projectId, description, risk})
    }


    renderDialog = () => {
        const { edit, setDescription, description, risk, toggleRisk, closeEdit } = this.props
        return (
            <Dialog
            active={edit}
            title={T.translate('project.description.dialog.title')}
            actions={[{label: "Cancel" , onClick: closeEdit }, {label: "Save", onClick: this.onSave }]}
            onOverlayClick={closeEdit}
            onEscKeyDown={closeEdit}
            className={styles.dialog}
            >
                <Divider styleName='topDivider'/>
                <div styleName='projDesc'>
                    <div>Project Description</div>
                    <Input value={description} onChange={setDescription} hint={'Enter a description...'} maxLength={150}/>
                </div>
                <div styleName='risk'>
                  <div>Change Project Type to Risk</div>
                  <Switch styleName='riskToggle' checked={risk} onChange={toggleRisk} />
                </div>
            </Dialog>
        )
    }

    renderDescription = ({description, risk, lastUpdateUserName, updatedAt}) => {
        if (!(description)) return (<div className={styles.noDesc}>No descriptions added</div>)
        return (<div>
          {risk && <FontIcon value='warning' className={styles.descRisk}/>}
          {`${description}`}<br/>
          <span className={styles.userTimeInfo}>{` (Updated by ${lastUpdateUserName} on ${getMonthDateYearString(new Date(updatedAt))})`}</span>
        </div>)
    }

  render() {
    const {
        collapse,
        descriptionSource,
        toggleCollapse,
        openEdit, 
    } = this.props
    const EditDescriptionIcon = showToTeam(() => (<div className={styles.sideIconWrapper}>
      {'['}<InfoButton 
              className={styles.sideIcon} 
              icon={"edit"} 
              theme={styles} 
              onClick={openEdit} 
              message={T.translate('pages.project.view.notification.viewProjectDescriptionEditInfo')}/>
      {"]"}
    </div>))

    return (
        <div className={styles.projectDescriptionContainer}>
          <MoreInfo className={styles.moreInfoButton} action={()=>toggleCollapse()} collapsed={collapse} text={`Project Description`}/>
          <EditDescriptionIcon/>
          {descriptionSource && 
            <Collapse collapse={collapse} theme={cn(styles.moreInfoCollapse, styles.projectDescriptionWrapper)} animateHeight={500}>
              {this.renderDescription(descriptionSource)}
            </Collapse>}
          {this.renderDialog()}
      </div>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: Sagas})
const withStyles = CSSModules(styles)
const enhance = compose(
    withConnect,
    withSagas,
    withStyles,
)

export default enhance(ProjectDescription)
